<xi-generic-modal
  [isVisible]="true"
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  maxWidth="450px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [isInteractive]="false">
      <div slot="children">
        <div
          *transloco="let t; read: 'widgets.taxonomy-search'"
          class="xi-modal__container taxonomy-search-dialog__container"
        >
          @if (isLoading) {
            <div class="xi-loader-container__inline-overlay">
              <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
            </div>
          }

          <h1 class="kxi-text-large xi-modal__title">{{ t('search-the-taxonomy') }}</h1>

          <div class="xi-modal__content">
            <form>
              <div class="taxonomy-search-bar__control-wrapper">
                <xi-search-box
                  [placeholder]="t('search-taxonomy-titles')"
                  [value]="query"
                  (onChangeOverride)="onSearch($event.detail.searchText)"
                  (onCancelClick)="filterTaxonomyNodes()"
                  class="taxonomy-search-bar__filter-control"
                ></xi-search-box>
              </div>
            </form>

            <div class="node-list">
              @if (!isLoading) {
                @for (node of filteredTaxonomyNodes; track node) {
                  <div>
                    {{ displayTaxonomyPath(node) }} /
                    <span class="taxonomy-node-link" (click)="setNode(node)">
                      {{ node.displayName ? node.displayName : node.nodeName }}
                    </span>
                    {{ t('numberof-documents', { count: node.docCount }) }}
                  </div>
                }
              }
            </div>
          </div>

          <div class="xi-modal__actions taxonomy-search__cancel">
            <xi-default-button
              [text]="t('cancel')"
              fill="text"
              (onClick)="cancel()"
            ></xi-default-button>
          </div>
        </div></div
    ></xi-basic-tile></div
></xi-generic-modal>
